// extracted by mini-css-extract-plugin
module.exports = {"font":"BuyMoreBalanceModal_font__AM_ai","button":"BuyMoreBalanceModal_button__7NHIZ"};